import React from 'react';

import Dropzone from '@components/modals/AttachFilesModal/components/Dropzone/Dropzone';
import ModalHeader from '@components/modals/ModalHeader/ModalHeader';
import Button from '@components/uikit/Button/Button';

import useTranslation from '@hooks/useTranslation';

import { useModalActions } from '@store/useModalStore';

import type { IGalleryPhoto } from '../../constants/sensorGalleryType';
import style from './style.module.scss';

const acceptFiles = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpeg', '.jpg'],
};

interface IProps {
  localFiles: IGalleryPhoto[];
  errorMessage: string;
  setLocalFiles: React.Dispatch<React.SetStateAction<IGalleryPhoto[]>>;
  onUploadPhotos: () => void;
}

const DropzoneStep = ({ localFiles, setLocalFiles, onUploadPhotos, errorMessage }: IProps) => {
  const { t } = useTranslation();

  const { setModalClose } = useModalActions();

  return (
    <div className={style.editGalleryModal}>
      <ModalHeader title={t('Photo management')} />
      <div className={style.modalBody}>
        <Dropzone currentFiles={localFiles} onDrop={setLocalFiles} typeOfFiles={acceptFiles} />
      </div>
      <div className={style.errorMessage}>
        <span>{t(errorMessage)}</span>
      </div>
      <div className={style.modalFooter}>
        <Button onClick={setModalClose} type="secondary" text={t('Cancel')} className={style.galleryButton} />
        <Button onClick={onUploadPhotos} type="primary" text={t('Next')} className={style.galleryButton} />
      </div>
    </div>
  );
};

export default DropzoneStep;
